import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Understand your dreams instantly', 'Spot patterns in your life', 'Make decisions with clarity', 'Turn dreams into self-awareness'];
  return <section className="py-14 px-2 sm:px-6 lg:px-8 mt-[-200px] mb-0" data-id="element-17">
      <div className="max-w-2xl mx-auto" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-19">
          <div className="space-y-4" data-id="element-20">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.15
          }} className="flex items-center gap-4 px-5 py-4 rounded-2xl bg-dark-card border border-dark-border" data-id="element-21">
                <CheckCircle2 className="w-5 h-5 text-gold shrink-0" data-id="element-22" />
                <span className="text-lg sm:text-xl text-zinc-200 font-light whitespace-nowrap" data-id="element-23">
                  {benefit}
                </span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}